{
  "point": "bod",
  "points": "body",
  "credits": "kredity",
  "loyaltyCredit": "Věrnostní kredit",
  "statusPoints": "Stavové body",
  "balancePoints": "Body k utracení",
  "edit": "Upravit",
  "delete": "Odstranit",
  "copyOf": "Kopie: {value}",
  "numberedCopyOf": "Kopie: {index} z {value}",
  "total": "celkem",
  "uplift": "navýšení prodeje",
  "approveBtn.label": "OK",
  "cancelBtn.label": "Zrušit",
  "createBtn.label": "Vytvořit",
  "saveBtn.label": "Uložit",
  "searchBtn.label": "Hledat",
  "updateBtn.label": "Aktualizovat",
  "applyBtn.label": "Použít",
  "addNewPlanBtn.label": "Přidat plán",
  "launchPlanBtn.label": "Spustit plán",
  "toOverviewBtn.label": "Přejít na přehled",
  "collapseBtn.label": "Sbalit",
  "extendBtn.label": "Detaily ",
  "updateAndSave.label": "Aktualizovat a uložit",
  "pleaseConfirmBtn.label": "Potvrdit",
  "closeBtn.label": "Zavřít",
  "resetBtn.label": "Resetovat",
  "confirmBtn.label": "Potvrdit",
  "status.inactive": "Neaktivní",
  "status.active": "Aktivní",
  "status.deactivated": "Deaktivováno",
  "status.scheduled": "Naplánováno",
  "status.expired": "Skončila platnost",
  "status.readyToUse": "Připraveno k použití",
  "status.readyToLaunch": "Připraveno ke spuštění",
  "status.empty": "Prázdné",
  "status.activity.pending": "Čeká na vyřízení",
  "status.activity.confirmed": "Potvrzeno",
  "status.activity.expired": "Skončila platnost",
  "status.activity.canceled": "Zrušeno",
  "status.activity.removed": "Odebráno",
  "status.default": "Standardní",
  "action.promotion": "Propagační akce",
  "action.referral": "Doporučení",
  "action.action": "Akce",
  "tiers.numberOfPurchases.plural.zero": "{number} nákupů",
  "tiers.numberOfPurchases.plural.one": "{number} nákup",
  "tiers.numberOfPurchases.plural.two": "{number} nákupy",
  "tiers.numberOfPurchases.plural.few": "{number} nákupy",
  "tiers.numberOfPurchases.plural.many": "{number} nákupů",
  "tiers.numberOfPurchases.plural.other": "{number} nákupů",
  "validity.unlimited": "Neomezeno",
  "validity.limitedFromEarn.value.days.plural.zero": "{number} dní",
  "validity.limitedFromEarn.value.days.plural.one": "{number} den",
  "validity.limitedFromEarn.value.days.plural.two": "{number} dny",
  "validity.limitedFromEarn.value.days.plural.few": "{number} dny",
  "validity.limitedFromEarn.value.days.plural.many": "{number} dní",
  "validity.limitedFromEarn.value.days.plural.other": "{number} dní",
  "validity.limitedFromEarn.value.weeks.plural.zero": "{number} týdnů",
  "validity.limitedFromEarn.value.weeks.plural.one": "{number} týden",
  "validity.limitedFromEarn.value.weeks.plural.two": "{number} týdny",
  "validity.limitedFromEarn.value.weeks.plural.few": "{number} týdny",
  "validity.limitedFromEarn.value.weeks.plural.many": "{number} týdnů",
  "validity.limitedFromEarn.value.weeks.plural.other": "{number} týdnů",
  "validity.limitedFromEarn.value.months.plural.zero": "{number} měsíců",
  "validity.limitedFromEarn.value.months.plural.one": "{number} měsíc",
  "validity.limitedFromEarn.value.months.plural.two": "{number} měsíce",
  "validity.limitedFromEarn.value.months.plural.few": "{number} měsíce",
  "validity.limitedFromEarn.value.months.plural.many": "{number} měsíců",
  "validity.limitedFromEarn.value.months.plural.other": "{number} měsíců",
  "days": "Dny",
  "dayInMonth": "Den",
  "month": "Měsíc",
  "months.1": "Leden",
  "months.2": "Únor",
  "months.3": "Březen",
  "months.4": "Duben",
  "months.5": "Květen",
  "months.6": "Červen",
  "months.7": "Červenec",
  "months.8": "Srpen",
  "months.9": "Září",
  "months.10": "Říjen",
  "months.11": "Listopad",
  "months.12": "Prosinec",
  "form.missingSettingsAlert": "Nejprve zadejte všechny povinné údaje, potom můžete po uložení pokračovat dalším krokem.",
  "noResults.title": "Nenašly se žádné výsledky.",
  "noResults.text": "Vašemu hledání „{text}“ neodpovídají žádné výsledky.",
  "alertContainer.editModeAlert.message": "Upravujete další verzi svého věrnostního plánu. Změny se projeví, až tuto verzi spustíte. ",
  "alertContainer.liveModeAlert.message.linkText": "Další informace",
  "alertContainer.liveModeAlert.message": "Pokud chcete upravovat úrovně nebo pevné a další výhody, vyberte ve Správě věrnostního programu možnost Aktualizovat a spustit a přepněte na úpravy další verze. {link}",
  "card.isRoadmap.text": "Itinerář",
  "catalogSelector.tooManyResults.title": "Našlo se příliš mnoho výsledků. ",
  "catalogSelector.tooManyResults.text": "Zkuste omezit počet výsledků zadáním přesnějších klíčových slov.",
  "catalogSelector.errorAlert": "Něco se pokazilo. Zkuste to znovu.",
  "catalogSelector.searchPlaceholder.byItem": "Hledejte konkrétní produkt.",
  "catalogSelector.searchPlaceholder.byCatOrBrand": "Konkrétní značky nebo kategorie, které chcete propagovat.",
  "catalogSelector.checkAllItems.label": "Vybrat vše",
  "catalogSelector.showAllSelections.label": "Zobrazit pouze vybrané položky.",
  "catalogSelector.cancelBtn.label": "Zavřít",
  "catalogSelector.saveBtn.label": "Použít a uložit",
  "catalogSelector.brands.plural.zero": "{number} značek",
  "catalogSelector.brands.plural.one": "{number} značka",
  "catalogSelector.brands.plural.two": "{number} značky",
  "catalogSelector.brands.plural.few": "{number} značky",
  "catalogSelector.brands.plural.many": "{number} značek",
  "catalogSelector.brands.plural.other": "{number} značek",
  "catalogSelector.category.plural.zero": "{number} kategorií",
  "catalogSelector.category.plural.one": "{number} kategorie",
  "catalogSelector.category.plural.two": "{number} kategorie",
  "catalogSelector.category.plural.few": "{number} kategorie",
  "catalogSelector.category.plural.many": "{number} kategorií",
  "catalogSelector.category.plural.other": "{number} kategorií",
  "catalogSelector.product.plural.zero": "{number} produktů",
  "catalogSelector.product.plural.one": "{number} produkt",
  "catalogSelector.product.plural.two": "{number} produkty",
  "catalogSelector.product.plural.few": "{number} produkty",
  "catalogSelector.product.plural.many": "{number} produktů",
  "catalogSelector.product.plural.other": "{number} produktů",
  "confirmNavDialog.discardChanges.text": "Nezapomeňte uložit změny. Pokud stránku opustíte, ztratíte neuložené změny.",
  "confirmNavDialog.approveBtn.label": "OK",
  "confirmNavDialog.cancelBtn.label": "Zrušit",
  "actionDashboard.overviewLinkText.referral": "Přejít k akcím doporučení",
  "actionDashboard.editLinkText": "Upravit program",
  "dashboardOptions.launchedAt": "Program byl spuštěn: ",
  "dashboardOptions.currentlyShowingLabel": "Aktuálně zobrazeno:",
  "dashboardOptions.viewLabel": "Zobrazit:",
  "masterActions.join.largeText": "Zapojení do věrnostního programu",
  "masterActions.purchases.largeText": "Nákup",
  "status.inactive.tooltip": "Nastavení nebyla dokončena.",
  "status.inactive.tooltip.proomotionEnded": "Tato propagační akce je neaktivní a nelze ji upravit. Můžete zkopírovat dosavadní propagační akci nebo vytvořit novou.",
  "status.inactive.tooltip.connectedToRewardPools": "Fond poukázek {name} má status {status}.",
  "status.inactive.tooltip.invalidPromotionRecurringDates": "Zkontrolujte datumy propagační akce.",
  "status.readyToUse.tooltip.promotion": "Tato propagační akce se již používá. Můžete ji automaticky zobrazit členům v peněžence nebo ji v editoru kampaní členům přiložit pomocí věrnostních tokenů.",
  "status.readyToUse.tooltip.attachable": "Akce je připravena k použití a může být připojena ke kontaktům v editoru kampaní pomocí věrnostních tokenů. ",
  "status.active.tooltip.promotion": "Tato propagační akce je aktivní a dostupná pro členy. ",
  "status.active.tooltip.attachable": "Tato akce je aktivní. Její nastavení nemůžete změnit. Abyste akci mohli upravovat, nejprve ji deaktivujte a počkejte na konec její platnosti. Můžete ji také zkopírovat, upravit kopii a spustit ji jako novou akci.",
  "status.active.tooltip.event": "Tato akce je aktivní. Můžete ji propojit s výhodami nebo programem automatizace. ",
  "status.deactivated.tooltip.promotion": "Tuto propagační akci jste deaktivovali a již není pro členy k dispozici.",
  "status.deactivated.tooltip.attachable": "Tuto akci jste deaktivovali. Abyste ji mohli upravit nebo odstranit, počkejte na konec její platnosti. Můžete ji také zkopírovat, upravit kopii a spustit ji jako novou akci.",
  "editorTypePopup.title": "Vybrat typ editoru",
  "editorTypePopup.text": "Zákazníkům bez exkluzivního přístupu se zobrazí stránka blokování. Můžete si vytvořit vlastní HTML stránku nebo použít některou z našich předloh.",
  "editorTypePopup.options.html.text": "Vytvořit uživatelskou stránku HTML",
  "editorTypePopup.options.template.text": "Vytvořit stránku z předlohy",
  "fileInputField.uploadBtn.label": "Nahrát",
  "fileInputField.browseBtn.label": "Procházet",
  "formStepsContainer.nextStep.text": "Další krok",
  "formStepsContainer.prevStep.text": "Předchozí krok",
  "iconGallery.title": "Galerie ikon věrnostního programu",
  "iconGallery.deleteDialog.headline": "Opravdu chcete tuto ikonu odstranit?",
  "iconGallery.deleteDialog.content": "Když tuto ikonu odstraníte, přestane se členům zobrazovat. Zkontrolujte, zda není propojená s akcí nebo poukázkou.",
  "iconGallery.uploadResult.successMessage": "Úspěšně nahráno.",
  "iconGallery.searchInput.placeholder": "Hledat ikonu podle názvu.",
  "iconGallery.fileUploader.tooltip": "<h3>Nahrát</h3><b>Požadavky na nahrávané ikony:</b></br>Soubor: SVG nebo PNG</br>Formát: čtverec<br>Maximální rozměry: 200x200 pixelů <br>Maximální velikost souboru: 100 KB</br><sub>* Doporučujeme transparentní pozadí </sub>.",
  "multiLangPopup.defaultNoticeText": "Vámi definovaný primární jazyk je standardním jazykem členů, když neexistují vhodná jazyková nastavení. ",
  "multiLangPopup.defaultTitle.currency": "Přepočet měny",
  "multiLangPopup.defaultTitle.language": "Překlad jazyka",
  "multiMarketSelector.multiSelectField.placeholder": "-- Vybrat trhy --",
  "multiMarketSelector.selectField.placeholder": "-- Vybrat trh --",
  "multiPlanSelect.label": "Vyberte si věrnostní plán ",
  "preLaunchPopup.conditions.plan.title": "Nastavení plánu",
  "preLaunchPopup.conditions.plan.text": "Zkontrolujte nastavení věrnostního plánu, abyste zajistili, že je vše správně nastaveno a že podmínky pro členy odpovídají. ",
  "preLaunchPopup.conditions.tiers.title": "Úrovně a výhody",
  "preLaunchPopup.conditions.tiers.text": "Zkontrolujte nastavení úrovní pro všechny členy a rozložení kontaktů v úrovních, aby vše odpovídalo vaší strategii. ",
  "preLaunchPopup.conditions.rewards.title": "Fondy odměn",
  "preLaunchPopup.conditions.rewards.text": "Zkontrolujte, zda jste nahráli dostatek kódů poukázek pro všechny reakce a zda je správně definována platnost všech fondů a poukázek. ",
  "preLaunchPopup.conditions.actions.title": "Akce",
  "preLaunchPopup.conditions.actions.text": "Zkontrolujte, zda vaše akce pokrývají všechny taktiky, které chcete použít, a zda jste aktivovali všechny standardní akce. ",
  "preLaunchPopup.title": "Opravdu chcete spustit svůj věrnostní plán?",
  "preLaunchPopup.text": "Zkontrolujte nastavení, abyste zajistili, že je váš věrnostní plán připraven ke spuštění:",
  "timeValidityInput.radioLabel.days": "Dny",
  "timeValidityInput.radioLabel.weeks": "Týdny",
  "timeValidityInput.radioLabel.months": "Měsíce",
  "ctaUrl": "URL výzvy k akci",
  "ctaText": "Text výzvy k akci",
  "message": "Zpráva",
  "pageNotFound": "Stránku, kterou hledáte, nemůžeme najít.",
  "externalEventSetup.title": "Externí událost věrnostního programu",
  "externalEventSetup.name.label": "Název externí události",
  "externalEventSetup.description.label": "Popis",
  "externalEventSetup.description.tooltip": "Popis je interní a pomůže vám při správě událostí věrnostního programu.",
  "pointsRatesFields.perDescriptor.points": "získáno za",
  "catalog.item.type.category.name": "Kategorie",
  "catalog.item.type.brand.name": "Značka",
  "catalog.item.type.item.name": "Produkt",
  "catalog.item.type.itemId.name": "ID položky",
  "exclusiveAccessOffers.options.fixedBenefit.title": "Přístup jako pevná výhoda",
  "exclusiveAccessOffers.options.additionalBenefits.title": "Přístup jako další výhoda",
  "exclusiveAccessOffers.options.action.title": "Přístup jako odměna za akci",
  "exclusiveAccessOffers.options.redemption.title": "Přístup za body",
  "exclusiveAccessOffers.options.redemptionForFree.title": "Bezplatný přístup",
  "accessValidityType.options.unlimited.name": "Přístup je platný neomezeně.",
  "accessValidityType.options.limitedFromEarn.name": "Přístup je platný po určitou dobu od okamžiku, kdy ho člen získá.",
  "accessValidityType.options.fixedDate.name": "Přístup je platný po předem definovanou dobu pro všechny členy.",
  "accessValidityType.options.disabled.fixedBenefit.name": "Deaktivovat dostupnost přístupu jako pevnou výhodu.",
  "accessValidityType.options.disabled.additionalBenefit.name": "Deaktivovat dostupnost přístupu jako další výhodu.",
  "accessValidityType.options.disabled.reward.name": "Deaktivovat dostupnost přístupu jako odměnu za akci.",
  "createOfModify.options.create.name": "Aktivovat nabídku",
  "createOfModify.options.create.tooltip": "Když aktivujete novou nabídku, její pravidla se resetují a budou k dispozici všem členům vybraných úrovní po definované období nabídky.",
  "createOfModify.options.create.tooltip2": "Když aktivujete novou nabídku, omezení aktivní nabídky se resetují a budou k dispozici všem členům vybraných úrovní po definované období nabídky. ",
  "createOfModify.options.modify.name": "Upravit aktivní nabídku",
  "createOfModify.options.modify.tooltip": "Když upravíte aktivní nabídku, změny neovlivní členy, kteří již nabídku využili.",
  "exclusiveAccessFormSteps.exclusiveAccessPoolSettings.title": "Nastavení exkluzivity",
  "exclusiveAccessFormSteps.exclusiveAccessBlockingEditor.title": "Stránka blokování",
  "exclusiveAccessFormSteps.redemptionValue.title": "Přístup a nabídky",
  "exclusiveAccessFormSteps.EXCLUSIVE_ACCESS_VALIDITY.title": "Aktivace",
  "activityElementPointsText.loyalty": "{{points_name}}",
  "activityElementPointsText.pointsToSpend": "{{points_name}} k utracení",
  "activityElementPointsText.status": "Status {{points_name}}",
  "activityElementPointsText.cashback": "Cashback",
  "activityElementPointsText.cashback.name": "{{cashback_name}}",
  "voucherTypeText.one_time": "Jednorázová poukázka",
  "voucherTypeText.yearly": "Poukázka na více použití",
  "exclusiveAccessTypeText.permanent": "Trvalý exkluzivní přístup",
  "exclusiveAccessTypeText.limitedTerm": "Exkluzivní přístup na omezenou dobu",
  "mainTabs.dashboard.title": "Panel",
  "mainTabs.actions.title": "Akce",
  "mainTabs.rewards.title": "Odměny",
  "mainTabs.tiers.title": "Úrovně",
  "mainTabs.loyaltyWallet.title": "Věrnostní peněženka",
  "mainTabs.memberProfiles.title": "Profily členů",
  "mainTabs.externalEvents.title": "Externí události",
  "mainTabs.planSettings.title": "Nastavení plánu",
  "mainTabs.vouchers.title": "Poukazy",
  "mainTabs.exclusiveAccesss.title": "Exkluzivní přístup",
  "mainTabs.loyaltyManagement.title": "Správa věrnostního programu",
  "mainTabs.security.title": "Konfigurace věrnostního programu",
  "actionTabs.purchases.title": "Nákupy",
  "actionTabs.promotions.title": "Propagační akce",
  "actionTabs.engagements.title": "Zapojení",
  "actionTabs.events.title": "Události",
  "actionTabs.referral.title": "Doporučení",
  "actionTabs.join.title": "Zapojení do věrnostního programu",
  "tierTabs.tiers.title": "Úrovně",
  "tierTabs.fixedBenefits.title": "Pevné výhody",
  "tierTabs.additionalBenefits.title": "Další výhody",
  "tierTabs.contactDistribution.title": "Diagram distribuce",
  "managementTabs.accountSettings.title": "Nastavení účtu",
  "managementTabs.languageAndCurrency.title": "Jazyk a měna",
  "managementTabs.planSettings.title": "Nastavení plánu",
  "managementTabs.cashbackSettings.title": "Nastavení ",
  "managementTabs.membershipSettings.title": "Nastavení členství",
  "managementTabs.updateAndLaunch.title": "Aktualizovat a spustit",
  "onboardingTabs.accountSettings.title": "Vytvoření plánu",
  "onboardingTabs.activation.title": "Aktivace",
  "customerCalcPeriod.options.1.name": "Posledních 30 dní",
  "customerCalcPeriod.options.2.name": "Posledních 60 dní",
  "customerCalcPeriod.options.3.name": "Posledních 90 dní",
  "customerCalcPeriod.options.6.name": "Posledních 6 měsíců",
  "customerCalcPeriod.options.12.name": "Posledních 12 měsíců",
  "planType.options.points.name": "Body a jejich uplatnění",
  "planType.options.points_and_benefits.name": "Body a výhody",
  "planType.options.spend.name": "Útrata a výhody",
  "planType.options.points.tooltip": "Plán založený na bodech s jednou nebo více úrovněmi a uplatněním bodů.",
  "planType.options.points_and_benefits.tooltip": "Plán založený na bodech s více úrovněmi bez možnosti uplatnění bodů.",
  "planType.options.spend.tooltip": "Plán založený na útratě s jednou nebo více úrovněmi a výhodami bez získávání bodů, ale s pravidly pro možnost cashbacku. V plánu založeném na útratě je vedena pouze jedna měna. Pokud používáte více měn, je nutné pro každou měnu spravovat jiný plán.",
  "pointsAllocatopmDelay.options.1.name": "24 hodin",
  "pointsAllocatopmDelay.options.2.name": "48 hodin",
  "pointsAllocatopmDelay.options.3.name": "72 hodin",
  "pointsAllocatopmDelay.options.7.name": "7 dní",
  "pointsAllocatopmDelay.options.14.name": "14 dní",
  "pointsAllocatopmDelay.options.21.name": "21 dní",
  "pointsAllocatopmDelay.options.30.name": "30 dní",
  "pointsAllocatopmDelay.options.40.name": "40 dní",
  "tierCalculationType.options.endOfYear.name": " Výpočet úrovní se provádí vždy 31. prosince každých [X let].",
  "tierCalculationType.options.endOfYear.tooltip": "Výpočet úrovní se provádí vždy k určenému datu každých [x let]. Členové, kterí upgradují na vyšší úroveň, budou mít svůj status na definovanou dobu.",
  "tierCalculationType.options.afterJoin.name": "Výpočet úrovní se provádí [X měsíců] od data, kdy člen na danou úroveň postoupil.",
  "tierCalculationType.options.afterJoin.tooltip": "Datum výpočtu úrovně se může lišit v závislosti na postupu člena v jednotlivých úrovních. Členové, kteří postoupí na vyšší úroveň, si zachovají svůj status úrovně alespoň po definované období. ",
  "tierCalculationType.options.endOfYear.spend.tooltip": "Při výpočtu úrovně se resetuje věrnostní kredit, ale členové si ponechají svůj status úrovně až do dalšího výpočtu. ",
  "tierCalculationType.options.noDropout.name": "Úrovně se nepočítají. Členové nemusejí splnit žádné požadavky, aby zůstali na stejné úrovni.",
  "tierCalculationType.options.noDropout.tooltip": "Body se sbírají pouze za účelem postupu do vyšších úrovní.",
  "statusPointsExpirationType.options.tierCalc.name": "Platnost stavových bodů končí a body se resetují k datu výpočtu úrovně.",
  "statusPointsExpirationType.options.tierCalc.tooltip": "Body se při výpočtu resetují, ale členové si zachovají svůj status úrovně až do dalšího výpočtu.",
  "statusPointsExpirationType.options.fromEarn.name": "Platnost stavových bodů končí a body se resetují každých [X měsíců] od data, kdy člen body získal.",
  "statusPointsExpirationType.options.fromEarn.tooltip": "Při výpočtu úrovní se započtou pouze body platné k danému dni. Členové si zachovají svůj status úrovně nebo klesnou na nižší úroveň.",
  "statusPointsExpirationType.options.never.name": "Platnost stavových bodů nikdy nekončí.",
  "loyaltyCreditExpirationType.options.tiersCalc.name": "Platnost věrnostního kreditu končí a kredit se resetuje k datu výpočtu úrovní.",
  "loyaltyCreditExpirationType.options.tiersCalc.tooltip": "Věrnostní kredit se při výpočtu resetuje, ale členové si zachovají svůj status úrovně až do dalšího výpočtu.",
  "loyaltyCreditExpirationType.options.fromEarn.name": "Platnost věrnostního kreditu končí a kredit se resetuje každých [X měsíců] od data, kdy člen kredit získal.",
  "loyaltyCreditExpirationType.options.fromEarn.tooltip": "Při výpočtu úrovní se započte pouze věrnostní kredit platný k danému dni. Členové si zachovají svůj status úrovně nebo klesnou na nižší úroveň.",
  "optIn.options.invitation.name": "Všechny kontakty jsou pozvány, aby se přidaly k věrnostnímu plánu.",
  "optIn.options.automatic.name": "Všechny kontakty se automaticky stanou členy věrnostního programu.",
  "historicalBalancePoints.options.keep.name": "Odměnit body k utracení.",
  "historicalBalancePoints.options.keep.tooltip": "Tato možnost pobízí členy, aby uplatnili své body za odměny.",
  "historicalBalancePoints.options.remove.name": "Neodměňovat body.",
  "historicalBalancePoints.options.remove.tooltip": "Body k utracení se resetují a členové musejí získat nové body, aby je mohli uplatnit.",
  "currencyIdentifierSigh.options.symbol.name": "Symbol měny",
  "currencyIdentifierSigh.options.symbol.tooltip": "Příklad: $500",
  "currencyIdentifierSigh.options.code.name": "ISO kód měny",
  "currencyIdentifierSigh.options.code.tooltip": "Příklad: 500 USD",
  "currencyIdentifierSigh.options.none.name": "Bez identifikátoru",
  "formStepRewards.options.poolSettings.title": "Nastavení fondu",
  "formStepRewards.options.uploadFile.title": "Nahrát soubor",
  "formStepRewards.options.redemptionValue.title": "Nastavení nabídky",
  "formStepRewards.options.validity.title": "Platnost",
  "specialTiers.redemptopmSettings.all.name": "Použití stejných nastavení pro všechny úrovně. Hodnoty jednotlivých úrovní se přepíší.",
  "voucherValidityType.options.unlimited.name": "Poukázka je platná bez omezení doby.",
  "voucherValidityType.options.limitedFromEarn.name": "Poukázka je platná po omezenou dobu od chvíle, kdy člen poukázku získal.",
  "voucherValidityType.options.fixedDate.name": "Poukázka je pro všechny členy platná po předem definovanou dobu.",
  "redemptionLimit.options.noLimit.name": "Automaticky pravidelně zobrazovat tuto nabídku členům.",
  "redemptionLimit.options.noLimit.tooltip": "Když tento přepínač aktivujete u dané úrovně, nabídka uplatnění se zobrazí ve věrnostní peněžence bez omezení uplatnění.",
  "redemptionLimit.options.limitMember.name": "Vyberte, kolikrát může každý člen uplatnit poukázku v období definovaném pro tuto nabídku.",
  "exclusiveAccessExclusivityType.options.name.fixed": "Trvalá exkluzivita",
  "exclusiveAccessExclusivityType.options.name.limitedTerm": "Časově omezená exkluzivita",
  "exclusiveAccessExclusivityType.options.name.limited": "Omezená exkluzivita",
  "editorContentTextDefaultValues.tag": "Exkluzivní přístup",
  "editorContentTextDefaultValues.firstHeader": "<strong>Dřívější černý pátek</strong>",
  "editorContentTextDefaultValues.secondHeader": "<strong>VÝPRODEJ</strong>",
  "editorContentTextDefaultValues.middleText": "Exkluzivní nabídky tzv. „černého pátku“ (Black Friday) pro naše věrné členy. Nezmeškejte je. Přidejte se k věrnostnímu plánu!",
  "editorContentTextDefaultValues.actionTopText": "Ještě nejste členem? Zapojte se do našeho věrnostního programu a začněte získávat odměny.",
  "editorContentTextDefaultValues.leftButton": "Zapojení do věrnostního programu",
  "editorContentTextDefaultValues.rightButton": "Až příště",
  "editorContentTextDefaultValues.actionBottomText": "<span>Již jste členem? <u>Přihlaste se</u></span>",
  "editorContentTextDefaultValues.middleText.mobile": "Exkluzivní nabídky pro věrné zákazníky. Nezmeškejte je. Přidejte se k věrnostnímu plánu!",
  "editorContentTextDefaultValues.actionTopText.mobile": "Ještě nejste členem? Zapojte se do našeho věrnostního programu.",
  "accessUrlType.options.exactUrl.name": "Blokovat a nabídnout exkluzivní přístup ke stránce:",
  "accessUrlType.options.startsWithUrl.name": "Blokovat a nabídnout exkluzivní přístup ke všem stránkám, jejichž adresa URL začíná:",
  "formStepsContainer.tierSettings.title": "Nastavení úrovně",
  "formStepsContainer.purchaseBenefits.title": "Výhody za nákup",
  "formStepsContainer.visibility.title": "Viditelnost",
  "tierDropout.options.yes.name": "Ano, tato úroveň se počítá a členové musejí splnit určité podmínky, aby na ní mohli zůstat.",
  "tierDropout.options.no.name": "Ne, z této úrovně není žádný scénář sestupu níže.",
  "fixedBenfitType.options.oneTimeVoucher.name": "Jednorázová poukázka",
  "fixedBenfitType.options.fixedYearlyVoucher.name": "Pevná roční poukázka (musí být využitelná vícekrát).",
  "fixedBenfitType.options.eventAction.name": "Událost",
  "fixedBenfitType.options.exclusiveAccess.name": "Exkluzivní přístup",
  "fixedBenfitType.options.custom.name": "Uživatelské (zadáváte nezávisle sami)",
  "fixedBenfitType.options.fixedYearlyVoucher.additional.name": "Poukázka na více použití (vyžaduje kód na více použití).",
  "tierTypeOptions.regular.name": "Na základě bodů",
  "tierTypeOptions.invite.name": "Pouze na pozvání",
  "tierTypeOptions.invite.tooltip.learnMoreLinkText": "Další informace",
  "tierTypeOptions.invite.tooltip": "Na danou úroveň mohou patřit pouze pozvaní nebo platící členové. Zpracujte platby a členství na své straně. Když chcete přidat členy na tuto úroveň, použijte API Věrnostní program nebo Profily členů. {learnMoreLink}.",
  "tierTypeOptions.spend.name": "Založeno na útratě",
  "exclusiveAccess.cardLabels.permanent": "Trvalé",
  "exclusiveAccess.cardLabels.limtedTerm": "Omezená doba",
  "cards.filterBar.moreFiltersButton": "Další filtry",
  "catalogSelector.selected.single": "Vybráno: {items}",
  "catalogSelector.selected.multiple": "Vybráno: {items} a {lastItems}",
  "iconGallery.uploadResult.failMessage": "Při nahrávání došlo k chybě. Ujistěte se, že soubory splňují požadavky. \n{showFileList,select,true{{failed} out of {total} failed: {failedDetails}} other{{failedDetails}}} ",
  "pointsRatesFields.perDescriptor.spend": "pro kaž.",
  "activityElementMultiuplyPointsText.double": "dvojnásob.",
  "activityElementMultiuplyPointsText.triple": "trojnásob."
}
